class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = this.querySelector('#cart-notification');
    this.notification.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
    this.notification.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-confirmation-close]')) this.close();
      if (event.target !== this.notification) return;
      const bounds = this.notification.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
    });
    this.notification.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        const controls = [...this.notification.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')]
          .filter((element) => !element.closest('[hidden], [inert]'));
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      }
    });
  }

  open() {
    if (!this.isConnected) return;
    if (!this.notification.open) this.notification.showModal();
    this.querySelector('#cart-notification-button').focus();
  }

  close() {
    if (!this.notification.open) return;
    this.notification.close();
    const canRestore = this.activeElement?.isConnected && !this.activeElement.disabled && !this.activeElement.closest('[hidden], [inert]');
    const target = canRestore ? this.activeElement : document.getElementById('cart-icon-bubble');
    target?.focus();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key || parsedState.items?.[0]?.key;
    let productRendered = false;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      const html = parsedState.sections?.[section.id];
      if (!element || typeof html !== 'string') return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = section.id === 'cart-notification-product'
        ? parsed.getElementById(`cart-notification-product-${this.cartItemKey}`)
        : parsed.querySelector('.shopify-section');
      if (!content) return;
      element.innerHTML = content.innerHTML;
      if (section.id === 'cart-notification-product') productRendered = true;
    });
    const product = this.querySelector('#cart-notification-product');
    if (!productRendered) product.replaceChildren();
    product.hidden = !productRendered;
    this.querySelector('[data-cart-confirmation-fallback]').hidden = productRendered;
    this.open();
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) customElements.define('cart-notification', CartNotification);
